import Form from "@/components/Form";
import { List } from "@/components/list/List";
import SaveButton from "@/components/SaveButton";
import { UseFormReturn } from "react-hook-form";
import { useEffect, useCallback } from "react";
import { InvoiceSpecificationStoresForm } from "@/schemas/invoiceSpecificationStoresForm";
import { useFormMergeWithDefaults } from "@/hooks/useFormMergeWithDefaults";

interface LaborCostsInStoresFormProps {
  onIncludeOnInvoiceChange?: (
    stores: InvoiceSpecificationStoresForm["stores"],
  ) => void;
  onEditLaborCostsInStores?: (
    values: InvoiceSpecificationStoresForm["stores"],
    dirtyFields: Record<string, unknown>,
  ) => Promise<void>;
  form: UseFormReturn<InvoiceSpecificationStoresForm>;
  defaultValues: InvoiceSpecificationStoresForm;
}

export const LaborCostsInStoresForm = ({
  onIncludeOnInvoiceChange,
  onEditLaborCostsInStores,
  form,
  defaultValues,
}: LaborCostsInStoresFormProps) => {
  const handleFormSubmit = useCallback(
    async (values: InvoiceSpecificationStoresForm) => {
      if (onEditLaborCostsInStores) {
        await onEditLaborCostsInStores(
          values.stores,
          form.formState.dirtyFields.stores || {},
        );
      }
    },
    [onEditLaborCostsInStores, form.formState.dirtyFields],
  );

  useEffect(() => {
    const subscription = form.watch((values, { name }) => {
      if (name?.endsWith(".include_on_invoice") && values?.stores) {
        onIncludeOnInvoiceChange?.(
          values.stores as InvoiceSpecificationStoresForm["stores"],
        );
      }
    });

    return () => subscription.unsubscribe();
  }, [form, onIncludeOnInvoiceChange]);

  useFormMergeWithDefaults(form, defaultValues);

  return (
    <Form form={form} handleSubmit={handleFormSubmit} className="h-full gap-1">
      <List.Content>
        <List.Status>
          <List.DirtyRowsStatus />
        </List.Status>
      </List.Content>
      <footer className="flex p-2 justify-end gap-6">
        <SaveButton />
      </footer>
    </Form>
  );
};
